import { useQuery } from "react-query";
import { getSongsCountAsync } from "@/lib/songs-manager";
import { Filter } from "@/models/models";
import { FilterType } from "@/models/enums";
import { isNil } from "lodash";
import toast from "react-hot-toast";

type UseArtistSongsCountParams = {
  id: string;
};

export const useArtistSongsCount = ({ id }: UseArtistSongsCountParams) => {
  const {
    data: count,
    isLoading,
    isError,
    refetch,
  } = useQuery(
    ["/artist/songs/count", { id }],
    async () => {
      const { count } = await getSongsCountAsync(undefined, [
        { id, type: FilterType.artistType },
      ] as Filter[]);
      return count;
    },
    {
      enabled: !isNil(id),
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      onError() {
        toast.error("Failed to get songs count.");
      },
    }
  );

  return {
    count,
    isLoading,
    isError,
    refetch,
  };
};

export default useArtistSongsCount;
